import React from "react";
import { Link } from "react-router-dom";

const asset = (path) => `${process.env.PUBLIC_URL || ""}/${path.replace(/^\/+/, "")}`;

const storeCards = [
  {
    name: "Offline Laundry",
    rating: "4.6",
    eta: "Today, 8 AM - 8 PM",
    distance: "2.3 km",
    status: "Open",
    image: "assets/images/thumbs/store-img1.png",
    offer: "25% OFF",
  },
  {
    name: "Bubble & Wash Laundry",
    rating: "4.8",
    eta: "Today, 9 AM - 9 PM",
    distance: "3.1 km",
    status: "Open",
    image: "assets/images/thumbs/store-img2.png",
    offer: "Free pickup",
  },
  {
    name: "Quick Clean Laundry",
    rating: "4.5",
    eta: "Tomorrow, 8 AM - 7 PM",
    distance: "4.4 km",
    status: "Busy",
    image: "assets/images/thumbs/vendors-two-img4.png",
    offer: "10% OFF",
  },
];

const washCategories = [
  ["Shirt", "assets/images/thumbs/product-img1.png"],
  ["T-Shirt", "assets/images/thumbs/product-img7.png"],
  ["Jeans", "assets/images/thumbs/product-img12.png"],
  ["Dress", "assets/images/thumbs/product-img13.png"],
  ["Kurta", "assets/images/thumbs/product-img16.png"],
];

const laundryItems = [
  ["Shirt", "Cotton, linen and office wear", "INR 60", "assets/images/thumbs/product-img1.png"],
  ["T-Shirt", "Round neck and polo t-shirts", "INR 50", "assets/images/thumbs/product-img7.png"],
  ["Kurta", "Regular and premium fabric", "INR 80", "assets/images/thumbs/product-img16.png"],
  ["Blouse", "Designer care included", "INR 90", "assets/images/thumbs/product-img13.png"],
  ["Sweater", "Soft wash and fold", "INR 120", "assets/images/thumbs/product-two-img8.png"],
];

const cartItems = [
  ["Shirt", "Wash + Iron", "2", "INR 120", "assets/images/thumbs/product-img1.png"],
  ["T-Shirt", "Wash + Fold", "1", "INR 50", "assets/images/thumbs/product-img7.png"],
  ["Kurta", "Dry cleaning", "1", "INR 130", "assets/images/thumbs/product-img16.png"],
];

const screenLinks = [
  ["home", "Home"],
  ["store", "Store per piece"],
  ["accordion", "Store accordion"],
  ["voucher", "Voucher"],
  ["product", "Product detail"],
  ["schedule", "Slot schedule"],
  ["schedule-pickup", "Schedule pickup"],
  ["schedule-dropoff", "Schedule dropoff"],
  ["schedule-notes", "Schedule notes"],
  ["basket", "Basket"],
  ["basket-pickup", "Basket pickup"],
  ["basket-dropoff", "Basket dropoff"],
];

export const getServiceBookingScreenTitle = (screen) => {
  const match = screenLinks.find(([key]) => key === screen);
  return match ? match[1] : "Home";
};

const AppHeader = ({ title = "Dryn Laundry", subtitle = "Bhopal, MP", backTo = "/service-booking/home", action }) => (
  <header className="sb-app-header">
    <Link className="sb-icon-button" to={backTo} aria-label="Go back">
      <i className="ph ph-caret-left" aria-hidden="true" />
    </Link>
    <div>
      <strong>{title}</strong>
      <span>{subtitle}</span>
    </div>
    {action || (
      <button className="sb-icon-button" type="button" aria-label="Notifications">
        <i className="ph ph-bell" aria-hidden="true" />
      </button>
    )}
  </header>
);

const BottomNav = () => (
  <nav className="sb-bottom-nav" aria-label="Laundry app navigation">
    {[
      ["home", "Home", "ph-house", "/service-booking/home"],
      ["orders", "Orders", "ph-list-checks", "/service-booking/basket"],
      ["wallet", "Wallet", "ph-wallet", "/service-booking/voucher"],
      ["account", "Account", "ph-user", "/service-booking/schedule"],
    ].map(([key, label, icon, to], index) => (
      <Link className={index === 0 ? "is-active" : ""} key={key} to={to}>
        <i className={`ph ${icon}`} aria-hidden="true" />
        <span>{label}</span>
      </Link>
    ))}
  </nav>
);

const SearchBar = ({ placeholder = "Search laundry, clothes or stores" }) => (
  <label className="sb-search">
    <i className="ph ph-magnifying-glass" aria-hidden="true" />
    <input type="search" placeholder={placeholder} aria-label={placeholder} />
  </label>
);

const PromoBanner = () => (
  <Link className="sb-promo-banner" to="/service-booking/store">
    <div>
      <span>Weekend Special</span>
      <h3>Get cleaner clothes by tomorrow</h3>
      <p>Pickup from your doorstep with verified laundry partners.</p>
    </div>
    <img src={asset("assets/images/thumbs/banner-img2.png")} alt="" />
  </Link>
);

const StoreCard = ({ store, compact = false }) => (
  <Link className={`sb-store-card ${compact ? "is-compact" : ""}`} to="/service-booking/store">
    <img src={asset(store.image)} alt="" />
    <div>
      <div className="sb-store-card__top">
        <strong>{store.name}</strong>
        <span>{store.offer}</span>
      </div>
      <p>{store.eta}</p>
      <div className="sb-meta-line">
        <span><i className="ph ph-star-fill" aria-hidden="true" />{store.rating}</span>
        <span><i className="ph ph-navigation-arrow" aria-hidden="true" />{store.distance}</span>
        <span className={store.status === "Open" ? "is-open" : "is-busy"}>{store.status}</span>
      </div>
    </div>
    <i className="ph ph-caret-right" aria-hidden="true" />
  </Link>
);

const ItemRow = ({ item, selected = false }) => (
  <Link className={`sb-item-row ${selected ? "is-selected" : ""}`} to="/service-booking/product">
    <img src={asset(item[3])} alt="" />
    <div>
      <strong>{item[0]}</strong>
      <span>{item[1]}</span>
      <small>Per piece</small>
    </div>
    <div className="sb-item-row__action">
      <b>{item[2]}</b>
      {selected ? (
        <span className="sb-stepper">
          <span aria-label="Decrease">-</span>
          <em>1</em>
          <span aria-label="Increase">+</span>
        </span>
      ) : (
        <span className="sb-item-row__add">Add</span>
      )}
    </div>
  </Link>
);

export const ServiceBookingHomeScreen = () => (
  <>
    <main className="sb-screen">
      <AppHeader title="Home" subtitle="Deliver to: Bhopal" backTo="/home" />
      <SearchBar />
      <PromoBanner />

      <section className="sb-section">
        <div className="sb-section-title">
          <h3>Services near you</h3>
          <Link to="/service-booking/store">View all</Link>
        </div>
        <div className="sb-service-grid">
          {[
            ["Wash", "ph-drop", "/service-booking/store"],
            ["Iron", "ph-t-shirt", "/service-booking/accordion"],
            ["Dry Clean", "ph-sparkle", "/service-booking/product"],
            ["Shoe", "ph-sneaker", "/service-booking/schedule"],
          ].map(([label, icon, to]) => (
            <Link to={to} key={label}>
              <span><i className={`ph ${icon}`} aria-hidden="true" /></span>
              <strong>{label}</strong>
            </Link>
          ))}
        </div>
      </section>

      <section className="sb-section">
        <div className="sb-section-title">
          <h3>Laundry store near you</h3>
        </div>
        <div className="sb-store-list">
          {storeCards.map((store) => <StoreCard store={store} key={store.name} />)}
        </div>
      </section>
    </main>
    <BottomNav />
  </>
);

export const ServiceBookingStoreScreen = ({ accordion = false, voucher = false }) => (
  <>
    <main className="sb-screen">
      <AppHeader title="Dryn Laundry" subtitle="Delivery in 24 hrs" />
      <SearchBar placeholder="Search clothes or services" />

      <div className="sb-store-tabs">
        <Link className="is-active" to="/service-booking/store">Per piece</Link>
        <Link to="/service-booking/accordion">Packages</Link>
        <Link to="/service-booking/voucher">Subscription</Link>
      </div>

      <Link className="sb-voucher-strip" to="/service-booking/voucher">
        <span><i className="ph ph-gift" aria-hidden="true" /> Welcome laundry offer</span>
        <b>Use SAVE20</b>
      </Link>

      <section className="sb-section">
        <div className="sb-section-title">
          <h3>What needs washing?</h3>
        </div>
        <div className="sb-category-strip">
          {washCategories.map(([label, image]) => (
            <Link to={label === "Shirt" ? "/service-booking/product" : "/service-booking/accordion"} key={label}>
              <img src={asset(image)} alt="" />
              <span>{label}</span>
            </Link>
          ))}
        </div>
      </section>

      <Link className="sb-offer-card" to="/service-booking/voucher">
        <div>
          <span>Exclusive offer for you</span>
          <strong>Flat 20% off on first order</strong>
        </div>
        <img src={asset("assets/images/thumbs/banner-three-img2.png")} alt="" />
      </Link>

      <section className="sb-section sb-products-section">
        <div className="sb-accordion-title">
          <h3>Top Wear</h3>
          <Link to={accordion ? "/service-booking/store" : "/service-booking/accordion"}>
            {accordion ? "Collapse" : "Expand"}
          </Link>
        </div>
        {(accordion ? laundryItems : laundryItems.slice(0, 3)).map((item, index) => (
          <ItemRow item={item} selected={index === 0} key={item[0]} />
        ))}
      </section>
    </main>
    <Link className="sb-floating-cart" to="/service-booking/basket">
      <span>1 item added</span>
      <strong>View basket</strong>
    </Link>
    {voucher && <VoucherModal />}
  </>
);

const VoucherModal = () => (
  <div className="sb-modal-backdrop">
    <section className="sb-voucher-modal" role="dialog" aria-modal="true">
      <Link className="sb-modal-close" to="/service-booking/store" aria-label="Close voucher">
        <i className="ph ph-x" aria-hidden="true" />
      </Link>
      <span className="sb-modal-handle" />
      <div className="sb-voucher-modal__icon">
        <i className="ph ph-gift" aria-hidden="true" />
      </div>
      <h3>Voucher Details</h3>
      <p>Apply this offer on laundry orders above INR 299. Valid on wash, iron and dry clean services.</p>
      <div className="sb-coupon-code">
        <span>SAVE20</span>
        <Link to="/service-booking/store">Apply</Link>
      </div>
    </section>
  </div>
);

export const ServiceBookingProductScreen = () => (
  <>
    <main className="sb-screen">
      <AppHeader title="Shirt" subtitle="Clean linen and cotton shirts" backTo="/service-booking/store" action={<Link className="sb-icon-button" to="/service-booking/basket" aria-label="Basket"><i className="ph ph-shopping-cart" /></Link>} />
      <section className="sb-product-hero">
        <img src={asset("assets/images/thumbs/product-img1.png")} alt="Shirt" />
        <div>
          <span>Per piece</span>
          <h2>Shirt</h2>
          <p>Clean, pressed and ready to wear.</p>
        </div>
      </section>

      <section className="sb-product-detail">
        <h3>Description</h3>
        <p>Best for daily wear shirts, office formals, cotton and linen fabric. Our partner checks stains before washing and packs every item separately.</p>
        <ul>
          <li><i className="ph ph-check-circle" /> Wash and iron included</li>
          <li><i className="ph ph-check-circle" /> Fabric-safe detergent</li>
          <li><i className="ph ph-check-circle" /> Delivery within selected slot</li>
        </ul>
      </section>

      <section className="sb-product-detail">
        <h3>Instructions</h3>
        <p>Remove valuable items from pockets. Mention stains or special care instructions before pickup.</p>
      </section>
    </main>
    <div className="sb-bottom-action">
      <div>
        <span>Total</span>
        <strong>INR 60</strong>
      </div>
      <Link to="/service-booking/schedule">Add for INR 60</Link>
    </div>
  </>
);

export const ServiceBookingScheduleScreen = ({ instruction = false, modal }) => (
  <>
    <main className="sb-screen">
      <AppHeader title="Slot Schedule" subtitle="Choose pickup and delivery" backTo="/service-booking/product" />
      <section className="sb-slot-card">
        <h3>When do you want your laundry picked up?</h3>
        <div className="sb-date-row">
          {["Thu 12", "Fri 13", "Sat 14", "Sun 15"].map((date, index) => (
            <Link className={index === 1 ? "is-active" : ""} to="/service-booking/schedule" key={date}>{date}</Link>
          ))}
        </div>
      </section>

      <section className="sb-slot-card">
        <h3>What time would you like us to arrive?</h3>
        <div className="sb-time-grid">
          {["8 AM - 10 AM", "10 AM - 12 PM", "2 PM - 4 PM", "6 PM - 8 PM"].map((time, index) => (
            <Link className={index === 1 ? "is-active" : ""} to="/service-booking/schedule" key={time}>{time}</Link>
          ))}
        </div>
      </section>

      <section className="sb-address-card">
        <div>
          <span>How do you want your laundry picked up?</span>
          <strong>Pick up at door</strong>
        </div>
        <Link to="/service-booking/schedule-pickup"><i className="ph ph-pencil-simple" /></Link>
      </section>

      <section className="sb-address-card">
        <div>
          <span>How do you want your laundry dropped off?</span>
          <strong>Contact me in person</strong>
        </div>
        <Link to="/service-booking/schedule-dropoff"><i className="ph ph-pencil-simple" /></Link>
      </section>

      <label className="sb-instruction-box" htmlFor="service-booking-instructions">
        <span>
          Any specific instructions?
          <Link to="/service-booking/schedule-notes">Add</Link>
        </span>
        <textarea id="service-booking-instructions" defaultValue={instruction ? "Please call before pickup. Keep whites separate." : ""} placeholder="Add notes for pickup or washing" />
      </label>
    </main>
    <div className="sb-bottom-action">
      <div>
        <span>Schedule</span>
        <strong>Fri, 10 AM</strong>
      </div>
      <Link to="/service-booking/basket">Confirm Slot</Link>
    </div>
    {modal === "pickup" && <ScheduleMethodModal type="pickup" />}
    {modal === "dropoff" && <ScheduleMethodModal type="dropoff" />}
    {modal === "notes" && <InstructionModal />}
  </>
);

export const ServiceBookingBasketScreen = ({ modal }) => (
  <>
    <main className="sb-screen">
      <AppHeader title="Your laundry basket" subtitle="3 items selected" backTo="/service-booking/schedule" />
      <section className="sb-basket-status">
        <i className="ph ph-check-circle" aria-hidden="true" />
        <div>
          <strong>Standard delivery</strong>
          <span>Your order will be ready as per selected slot.</span>
        </div>
      </section>

      <section className="sb-section">
        <div className="sb-basket-items">
          {cartItems.map((item) => (
            <article className="sb-basket-item" key={item[0]}>
              <img src={asset(item[4])} alt="" />
              <div>
                <strong>{item[0]}</strong>
                <span>{item[1]}</span>
                <small>Qty {item[2]}</small>
              </div>
              <b>{item[3]}</b>
            </article>
          ))}
        </div>
      </section>

      <section className="sb-summary-card">
        <h3>Bill Summary</h3>
        <div><span>Items total</span><b>INR 300</b></div>
        <div><span>Delivery fee</span><b>INR 40</b></div>
        <div><span>Coupon discount</span><b className="is-green">-INR 60</b></div>
        <div><strong>To Pay</strong><strong>INR 280</strong></div>
      </section>

      <section className="sb-address-card">
        <div>
          <span>Pickup method</span>
          <strong>Pick up at door</strong>
        </div>
        <Link to="/service-booking/basket-pickup"><i className="ph ph-pencil-simple" /></Link>
      </section>

      <section className="sb-address-card">
        <div>
          <span>Drop off method</span>
          <strong>Contact me in person</strong>
        </div>
        <Link to="/service-booking/basket-dropoff"><i className="ph ph-pencil-simple" /></Link>
      </section>
    </main>
    <div className="sb-bottom-action">
      <div>
        <span>Total</span>
        <strong>INR 280</strong>
      </div>
      <Link to="/service-booking/home">Confirm Pickup</Link>
    </div>
    {modal === "pickup" && <MethodModal type="pickup" />}
    {modal === "dropoff" && <MethodModal type="dropoff" />}
  </>
);

const ScheduleMethodModal = ({ type }) => {
  const isPickup = type === "pickup";
  return (
    <div className="sb-modal-backdrop">
      <section className="sb-method-modal" role="dialog" aria-modal="true">
        <Link className="sb-modal-close" to="/service-booking/schedule" aria-label="Close method">
          <i className="ph ph-x" aria-hidden="true" />
        </Link>
        <span className="sb-modal-handle" />
        <h3>{isPickup ? "Pick Up Method" : "Drop Off Method"}</h3>
        <p>{isPickup ? "How do you want your laundry picked up?" : "How do you want your laundry dropped off?"}</p>
        <Link className="is-active" to="/service-booking/schedule">{isPickup ? "Pick up at door" : "Contact me in person"}</Link>
        <Link to="/service-booking/schedule">{isPickup ? "Collect from me in person" : "Drop at door"}</Link>
        <Link to="/service-booking/schedule" className="sb-modal-done">Done</Link>
      </section>
    </div>
  );
};

const InstructionModal = () => (
  <div className="sb-modal-backdrop">
    <section className="sb-method-modal" role="dialog" aria-modal="true">
      <Link className="sb-modal-close" to="/service-booking/schedule" aria-label="Close instructions">
        <i className="ph ph-x" aria-hidden="true" />
      </Link>
      <span className="sb-modal-handle" />
      <h3>Additional instructions?</h3>
      <p>Add pickup, wash or delivery notes for the laundry partner.</p>
      <textarea className="sb-modal-textarea" defaultValue="Please call before pickup. Keep whites separate." />
      <Link to="/service-booking/schedule" className="sb-modal-done">Done</Link>
    </section>
  </div>
);

const MethodModal = ({ type }) => {
  const isPickup = type === "pickup";
  return (
    <div className="sb-modal-backdrop">
      <section className="sb-method-modal" role="dialog" aria-modal="true">
        <Link className="sb-modal-close" to="/service-booking/basket" aria-label="Close method">
          <i className="ph ph-x" aria-hidden="true" />
        </Link>
        <span className="sb-modal-handle" />
        <h3>{isPickup ? "Pick Up Method" : "Drop Off Method"}</h3>
        <p>{isPickup ? "How do you want your laundry picked up?" : "How do you want your laundry dropped off?"}</p>
        <Link className="is-active" to="/service-booking/basket">{isPickup ? "Pick up at door" : "Contact me in person"}</Link>
        <Link to="/service-booking/basket">{isPickup ? "Collect from me in person" : "Drop at door"}</Link>
        <Link to="/service-booking/basket" className="sb-modal-done">Done</Link>
      </section>
    </div>
  );
};

export const renderServiceBookingScreen = (screen) => {
  if (screen === "store") return <ServiceBookingStoreScreen />;
  if (screen === "accordion") return <ServiceBookingStoreScreen accordion />;
  if (screen === "voucher") return <ServiceBookingStoreScreen voucher />;
  if (screen === "product") return <ServiceBookingProductScreen />;
  if (screen === "schedule") return <ServiceBookingScheduleScreen />;
  if (screen === "schedule-pickup") return <ServiceBookingScheduleScreen modal="pickup" />;
  if (screen === "schedule-dropoff") return <ServiceBookingScheduleScreen modal="dropoff" />;
  if (screen === "schedule-notes") return <ServiceBookingScheduleScreen instruction modal="notes" />;
  if (screen === "basket") return <ServiceBookingBasketScreen />;
  if (screen === "basket-pickup") return <ServiceBookingBasketScreen modal="pickup" />;
  if (screen === "basket-dropoff") return <ServiceBookingBasketScreen modal="dropoff" />;
  if (screen === "pickup") return <ServiceBookingScheduleScreen modal="pickup" />;
  if (screen === "dropoff") return <ServiceBookingScheduleScreen modal="dropoff" />;
  return <ServiceBookingHomeScreen />;
};
